import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent, CircularProgress } from '@mui/material';

export default function AiAutoMapConfirmDialog({ modalOpen, handleDialogCancel, handleDialogConfirm, statusMessage, mappingInProgress }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const aiAutoMappingState = useSelector(state => state.treeData.aiAutoMapping);

  const dialogTitle = aiAutoMappingState ? t("AI_MAPPING_IN_PROGRESS_TITLE") : t('AI_AUTOMAP_CONFIRM_DIALGOG_TITLE');
  const dialogContent = aiAutoMappingState ? t("AI_MAPPING_IN_PROGRESS_CONTENT") : t('AI_AUTOMAP_CONFIRM_DIALOG_CONFIRM_TEXT');

  const handleCloseGate = () => {
    if (!aiAutoMappingState) {
      handleDialogCancel();
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <Dialog open={modalOpen} maxWidth='sm' onClose={handleCloseGate}>
        <DialogTitle className="dialog-header padding-12">
          <div className='flex align-center'>
            <span className="AI_BLACK" style={{ marginRight: "10px", height: "28px", width: "28px" }}></span>
            <div className='title'> {dialogTitle} </div>
          </div>
        </DialogTitle>
        <DialogContent className='modal-content' dividers style={{ width: 'unset' }}>
          <div>{dialogContent}</div>
          <div><b>{statusMessage ? `${t('COL_STATUS')}:` : ''}</b> {statusMessage}</div>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={handleDialogCancel}
            disabled={aiAutoMappingState}
          >
            {t('BTN_CANCEL')}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={handleDialogConfirm}
            disabled={aiAutoMappingState}
          >
            {t('BTN_PROCEED')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
